import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitTo'
})
export class LimitToPipe implements PipeTransform {
  transform(value: string | any[], limit: number): string | any[] {
    if (!value) return value;
    
    if (typeof value === 'string') {
      return value.slice(0, limit);
    }
    
    return value.slice(0, limit);
  }
}
